var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRole18(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 20C1.21667 20 0.979167 19.9042 0.7875 19.7125C0.595833 19.5208 0.5 19.2833 0.5 19V14C0.5 13.45 0.695833 12.9792 1.0875 12.5875C1.47917 12.1958 1.95 12 2.5 12V8C2.5 7.45 2.69583 6.97917 3.0875 6.5875C3.47917 6.19583 3.95 6 4.5 6H8.5V4.55C8.2 4.35 7.95833 4.10833 7.775 3.825C7.59167 3.54167 7.5 3.2 7.5 2.8C7.5 2.55 7.55 2.30417 7.65 2.0625C7.75 1.82083 7.9 1.6 8.1 1.4L9.5 0L10.9 1.4C11.1 1.6 11.25 1.82083 11.35 2.0625C11.45 2.30417 11.5 2.55 11.5 2.8C11.5 3.2 11.4083 3.54167 11.225 3.825C11.0417 4.10833 10.8 4.35 10.5 4.55V6H14.5C15.05 6 15.5208 6.19583 15.9125 6.5875C16.3042 6.97917 16.5 7.45 16.5 8V12C17.05 12 17.5208 12.1958 17.9125 12.5875C18.3042 12.9792 18.5 13.45 18.5 14V19C18.5 19.2833 18.4042 19.5208 18.2125 19.7125C18.0208 19.9042 17.7833 20 17.5 20H1.5ZM4.5 12H14.5V8H4.5V12ZM2.5 18H16.5V14H2.5V18Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRole18);
export default __webpack_public_path__ + "static/media/role18.26b6aa671a1d95fadd7f5391e94ff81f.svg";
export { ForwardRef as ReactComponent };